import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { IContextualMenu } from '../common/models/contextual-menu.model';
import {  EMutualfundsServiceCode } from '../common/models/service-code.model';
import { HttpRequestPayload, IHttpSuccessPayload } from '../core/models/http.model';
import { HttpProviderService } from '../core/services/http-provider/http-provider.service';
import { IMutualFunds, IMutualFundsAccountDetail, IMutualFundsProduct } from '../models/account-info.model';
import { MutualDetail, MutualFundInfo } from '../models/mutual-funds.module';
import { ProvidehttpService } from '../providehttp.service';
import { CustomerService } from './customer.service';

@Injectable({
  providedIn: 'root'
})
export class MutualFundsService {
  private _mutualFundInfo:Map<string, IMutualFundsProduct> = new Map<string, IMutualFundsProduct>();

  selectedMutualAccount:MutualFundInfo;
  mutualFundAccountList: IMutualFundsAccountDetail[] = [];
  contextualMenuList: IContextualMenu[] = [
    {
      id: 'M001',
      icon: 'purchase-order',
      name: 'CONTEXTULAMENU.purchaseOrder',
      title: 'Purchase Order',
      path: ['shell', 'mutual-funds', 'purchase-order'],
      desktopPath: ['home', 'transactions', 'mutual-funds', 'purchase-order'],
      serviceCode : EMutualfundsServiceCode.PURCHASE_ORDER
    },
    {
      id: 'M002',
      icon: 'sell-order',
      name: 'CONTEXTULAMENU.sellOrder',
      title: 'Sell Order',
      path: ['shell', 'mutual-funds', 'sell-order'],
      desktopPath: ['home', 'transactions', 'mutual-funds', 'sell-order'],
      serviceCode : EMutualfundsServiceCode.SELL_ORDER
    }
  ];

  constructor(
    private _customerService: CustomerService,
    private _httpProvider:HttpProviderService
  ) { }

  getMenuList():IContextualMenu[]{
    return this.contextualMenuList;
  }

  getSelectedMenuData(menuId: string) {
    const selectedMenuItem = this.contextualMenuList.find(
      (item) => item.id == menuId
    );
    return selectedMenuItem;
  }

  /**
   * 
   * @param accountNumber 
   * @returns IMutualFundsProduct
   */
  fetchMutualInfo(accountNumber: string): Observable<IMutualFundsProduct> {

    const httpRequest: HttpRequestPayload = {
      resource: "/mutualFund/" + accountNumber,
      method: "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        this._mutualFundInfo.set(accountNumber, res.body['mutualFund']);
        return this._mutualFundInfo.get(accountNumber);
      }));
  }

  /**
   *
   * @param accountNumber
   * @returns
   */
   getMutualAccountList():IMutualFundsAccountDetail[] {
    this.mutualFundAccountList = [];
      let mutualFunds: IMutualFunds = this._customerService.getMutualFundsOverview();
      if(mutualFunds && mutualFunds.product){
        mutualFunds.product.forEach(element => {
          let fundCardData = {
            ...element.accountDetails[0]
          };
          this.mutualFundAccountList.push(fundCardData);
        });
      }
      return this.mutualFundAccountList;
    }
   getMutualFundProductDetail(accountNumber) {
    let productList = this._customerService.getMutualFundsSummary();
    for (let index = 0; index < productList.length; index++) {
        if(productList[index].accountDetails.find(res=> {return res.accountNumber == accountNumber})) {
            return productList[index];
        }
    }
   }
  getMutualInfo(accountNumber: string): Observable<IMutualFundsProduct> {
    if (this._mutualFundInfo.has(accountNumber)) {
      return of(this._mutualFundInfo.get(accountNumber));
    } else {
      return this.fetchMutualInfo(accountNumber).pipe(
        map(
          (res) => {
            return this._mutualFundInfo.get(accountNumber)
          }
        )
      );
    }
  }
}
